module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-hedo-00.1@2x.428523a7.jpg";